module.exports = __webpack_public_path__ + "img/Event-Driven_Architecture.d3224051.gif";